import { render, staticRenderFns } from "./PersonalCardComponent.vue?vue&type=template&id=216d33be"
import script from "./PersonalCardComponent.vue?vue&type=script&lang=js"
export * from "./PersonalCardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports